import { useMutation, useQuery } from '@tanstack/react-query'
import { makePayment, subscriptionPackageList, subscriptionPackageDetail, companyPaymentResourceList, upgradePayment } from '../api/subscriptions';

export const useSubscriptionPackagesListQuery = (queryParams = '') => {
    return useQuery({
      queryKey: ['subscriptionPackagesList', queryParams],
      queryFn: () => subscriptionPackageList(queryParams),
      enabled: queryParams !== null
    });
};

export const useSubscriptionPackageDetailQuery = (queryParams = '') => {
    return useQuery({
      queryKey: ['subscriptionPackagesDetail', queryParams],
      queryFn: () => subscriptionPackageDetail(queryParams),
      enabled: queryParams !== null
    });
};

export const useCompanyPaymentResourceListQuery = (queryParams = '') => {
    return useQuery({
      queryKey: ['savedCards', queryParams],
      queryFn: () => companyPaymentResourceList(queryParams)
    });
};

export const useMakePaymentEvent = () => {
    return useMutation({
      mutationFn: makePayment
    })
};

export const useUpgradePlan = () => {
    return useMutation({
      mutationFn: upgradePayment
    })
};